import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5310dbb4")

_pushScopeId("data-v-5310dbb4")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "saturation-white" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "saturation-black" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "saturation-circle" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "saturation",
    ref: "saturationRef",
    style: { background: _ctx.bgColor },
    onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleMouseDown($event))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", {
      class: "saturation-pointer",
      style: {
        top: _ctx.pointerTop,
        left: _ctx.pointerLeft,
      }
    }, [
      _hoisted_3
    ], 4)
  ], 36))
})